import type { JsonObject } from '@/app-package';
import type { SupraLockboxDoc } from '@bb/domain/dist/schemas';

import axios from 'axios';

const getSupraLockboxData = async (params: {
  searchText?: string;
  cartonNumber?: string;
  mlsStaffOrgId?: string;
  ownerId?: string;
  ownerType?: 'org' | 'branch' | 'user' | 'office';
  ownerBranchIndex?: string;
  assigneeId?: string;
  assigneeType?: 'org' | 'branch' | 'user' | 'office';
  assigneeBranchIndex?: string;
  lockboxStatuses?: string[];
  includeGrantedLockboxes?: boolean;
  includeMlsNumbers?: boolean;
  includeOfficePhoneNumbers?: boolean;
  strictOwnershipMatching?: boolean;
  requireOwnerAsMLS?: boolean;
  filterBySupraOwnerMapping?: boolean;
  page?: number;
}) => {
  const { data } = await axios.get<{
    lockboxes: (JsonObject<SupraLockboxDoc> & {
      mlsOwnerName?: string;
      branchOwnerName?: string;
      orgOwnerName?: string;
    })[];
    lockboxCount: number;
  }>('/supra/lockbox', { params });

  return data;
};

export default getSupraLockboxData;
